import React from 'react';
import { Box, Typography, LinearProgress, useTheme } from '@mui/material';
import PremiumCard from './PremiumCard';

interface MetricCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  progressValue?: number; // Valor percentual para barra de progresso (ex: 0 a 100)
  progressColor?: 'primary' | 'secondary' | 'success' | 'warning' | 'error';
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  subtitle,
  icon,
  progressValue,
  progressColor = 'primary',
}) => {
  const theme = useTheme();

  return (
    <PremiumCard sx={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
      <Box>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
          {icon && (
            <Box sx={{ color: theme.palette[progressColor].main, display: 'flex', alignItems: 'center' }}>
              {icon}
            </Box>
          )}
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 1, letterSpacing: '-0.02em' }}>
          {value}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="text.secondary">
            {subtitle}
          </Typography>
        )}
      </Box>
      {progressValue !== undefined && (
        <Box sx={{ mt: 3 }}>
          <LinearProgress
            variant="determinate"
            value={progressValue}
            color={progressColor}
            sx={{ height: 6, borderRadius: 3 }}
          />
        </Box>
      )}
    </PremiumCard>
  );
};

export default MetricCard;
